<template>
  <div id="header">
    <header class="py-4">
      <div class="container-xxl">
        <div class="d-flex flex-wrap align-items-streach justify-content-center justify-content-lg-start">
            <div id="logo">
                <a :href="basePath">
                    <img class="me-4" />
                </a>
            </div>
          <span class="text-white d-none d-xl-inline" v-if="$store.getters['users/isAuth']" >
                        <font-awesome-icon :icon="['fas', 'circle-user']" />
                        {{ $t('app.welcome') }}, <span class="fw-medium">{{ user.name }}</span>!
                    </span>
          <h1 class="text-center mb-0 d-flex align-items-center justify-content-center flex-fill text-white fw-normal">{{ $t('app.title') }}</h1>
          <ul class="nav">
            <li class="nav-item">
              <app-lang-switcher />
            </li>
            <li class="nav-item">
              <app-currencies-switcher />
            </li>
            <li class="nav-item">
              <a
                  v-if="!$store.getters['users/isAuth']"
                  @click="openLoginModal"
                  class="nav-link px-2 header-btn text-white">
                {{ $t('app.login') }} <font-awesome-icon :icon="['fas', 'right-to-bracket']" />
              </a>
              <a
                  v-else
                  @click="logout"
                  class="nav-link px-2 header-btn text-white">
                {{ $t('app.logout') }} <font-awesome-icon :icon="['fas', 'right-to-bracket']" />
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="d-flex justify-content-center">
        <app-nav />
      </div>
    </header>

    <div class="modal-container">
      <login-modal ref="loginModal" />
    </div>

  </div>
</template>

<script>
import AppNav from './AppNav.vue'
import AppLangSwitcher from './AppLangSwitcher.vue'
import AppCurrenciesSwitcher from './AppCurrenciesSwitcher.vue'
import LoginModal from '@/modules/login/LoginModal.vue'
import { mapState } from 'vuex'

export default {
  name: 'AppHeader',
  components: {
    AppNav, AppLangSwitcher, LoginModal, AppCurrenciesSwitcher
  },
  computed: {
    ...mapState({
      user: state => state.users.user,
    }),
    basePath() {
        return process.env.VUE_APP_BASE_URL;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('users/logout', this.$router)
    },
    openLoginModal() {
      this.$refs.loginModal.open();
    }
  },
  mounted(){

  }
}
</script>
